<template>
    <div class="footer">
        <div class="bg-verde">
            <div class="conteudo">
                <div data-aos="fade-right" data-aos-duration="1000" class="div1">
                    <label class="t1">Nos acompanhe nas redes sociais.</label>
                    <a href="https://www.facebook.com/Planti-App-118228620091995/" target="_blank"><img class="social1" src="../../assets/images/face_claro.svg" alt=""></a>
                    <a href="https://www.instagram.com/plantiapp/" target="_blank"><img class="social2" src="../../assets/images/insta_claro.svg" alt=""></a>
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" class="div2">
                    <label class="t2">Baixe nosso aplicativo:</label>
                    <a href="https://apps.apple.com/br/app/planti/id1533612038" target="_blank"><img class="loja1" src="../../assets/images/app-store.svg" alt=""></a>
                    <a href="https://play.google.com/store/apps/details?id=com.misie.planti" target="_blank"><img class="loja2" src="../../assets/images/google-play.svg" alt=""></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style scoped lang="scss">
.footer{
    position: relative;
}
.bg-verde{
    width: 100%;
    height: 230px;
    background: linear-gradient(258.32deg, #93F9B9 0%, #1D976C 99.73%);
    position: relative;
}
.conteudo{
    position: relative;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    max-width: 1300px;
}

.t1{
    position: absolute;
    top: 20px;
    left: 30px;
    width: 285px;
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    line-height: 34px;
    letter-spacing: 0.75px;
    color: #F2F2F2;
}

.social1{
    position: absolute;
    left: 30px;
    top: 100px;
    width: 32px;
    height: 32px;
}
.social2{
    position: absolute;
    left: 90px;
    top: 100px;
    width: 32px;
    height: 32px;
}

.t2{
    position: absolute;
    top: 20px;
    left: 550px;
    width: 285px;
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    line-height: 34px;
    letter-spacing: 0.75px;
    color: #F2F2F2;
}
.loja1{
    position: absolute;
    left: 550px;
    top: 75px;
    width: 120px;
    height: 40px;
}
.loja2{
    position: absolute;
    left: 700px;
    top: 75px;
    width: 133px;
    height: 40px;
}



@media screen and (max-width: 1050px) {
    .t2{
        top: 20px;
        left: 430px;
    }
    .loja1{
        left: 430px;
        top: 75px;
    }
    .loja2{
        left: 570px;
        top: 75px;
    }
}

@media screen and (max-width: 767px) {
    .conteudo{
        max-width: 340px;
        position: relative;

    }
    .bg-verde{
        overflow: hidden;
        width: 100%;
        height: 430px;
        background: linear-gradient(258.32deg, #93F9B9 0%, #1D976C 99.73%);
        position: relative;
    }
    .t1{
        position: absolute;
        top: 200px;
        left: 30px;
        width: 288px;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        text-align: center;
        line-height: 34px;
        letter-spacing: 0.75px;
        color: #F2F2F2;
    }

    .social1{
        left: 122px;
        top: 290px;
    }
    .social2{
        left: 183px;
        top: 290px;
    }

    .t2{
        position: absolute;
        top: 40px;
        left: 51px;
        width: 285px;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 34px;
        letter-spacing: 0.75px;
        color: #F2F2F2;
    }
    .loja1{
        left: 110px;
        top: 90px;
        width: 127px;
    }
    .loja2{
        left: 110px;
        top: 142px;
        width: 123px;
    }
}


</style>
